export default __webpack_public_path__ + "static/media/foodx_main2.1e42c7ef.PNG";